// TEMP: Mock API for development/demo purposes
// This file should be removed when the feature is no longer needed

/**
 * Mock API that simulates checking if a user has scanned into a store
 * @returns Promise that resolves to true
 */
export const hasUserScannedIntoStore = async (): Promise<boolean> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300))
    return true
}
